import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HourlyCarPriceService from "../../services/hourlycarcharges.service";

// Fetch Hourly Car Charges
export const gethourlyCarChargesList = createAsyncThunk(
  "hourlyCarCharges/gethourlyCarChargesList",
  async (item, thunkApi) => {
    try {
      const response = await HourlyCarPriceService.gethourlyCarCharges(item);
     
      return  response.data ;
    } catch (error) {
      
      return thunkApi.rejectWithValue({
        message: error.response?.data?.message || error.message || error.toString(),
      });
    }
  }
);

// Create Hourly Car Charges
export const posthourlyCarCharges = createAsyncThunk(
  "hourlyCarCharges/posthourlyCarCharges",
  async (item, thunkAPI) => {
    try {
      const response = await HourlyCarPriceService.addhourlyCarCharges(item);
      return   response.data ;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error.response?.data?.message || error.message || error.toString(),
      });
    }
  }
);

// Update Hourly Car Charges
export const puthourlyCarCharges = createAsyncThunk(
  "hourlyCarCharges/puthourlyCarCharges",
  async (item, thunkAPI) => {
    try {
      const response = await HourlyCarPriceService.edithourlyCarCharges(item);
      return response.data ;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error.response?.data?.message || error.message || error.toString(),
      });
    }
  }
);

// Delete Hourly Car Charges
export const deletehourlyCarCharges = createAsyncThunk(
  "hourlyCarCharges/deletehourlyCarCharges",
  async (id, thunkAPI) => {
    try {
      const response = await HourlyCarPriceService.deletehourlyCarCharges(id);
      return response.data ;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error.response?.data?.message || error.message || error.toString(),
      });
    }
  }
);

// Initial State
const initialState = {
  loading: false,
  error: "",
  packageData: [],
  isLoggedIn: false,
};

// Create Slice
const hourlyCarChargesSlice = createSlice({
  name: "hourlyCarCharges",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = "";
      state.packageData = [];
      state.isLoggedIn = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(gethourlyCarChargesList.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.packageData = [];
      })
      .addCase(gethourlyCarChargesList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.packageData = action.payload?.hourlyCarCharges?.packageData || [];
        state.isLoggedIn = true;
      })
      .addCase(gethourlyCarChargesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch data";
        state.packageData = [];
        state.isLoggedIn = false;
      })
      .addCase(posthourlyCarCharges.fulfilled, (state, action) => {
        state.packageData.push(action.payload.hourlyCarCharges);
      })
      .addCase(puthourlyCarCharges.fulfilled, (state, action) => {
        state.packageData = state.packageData.map((item) =>
          item.id === action.payload.hourlyCarCharges.id
            ? action.payload.hourlyCarCharges
            : item
        );
      })
      .addCase(deletehourlyCarCharges.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.packageData = state.packageData.filter((item) => item.id !== deletedId);
      });
  }
});

// Export Reducer & Actions
export const { resetState } = hourlyCarChargesSlice.actions;
export default hourlyCarChargesSlice.reducer;
